import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

class MessageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.show}
          toggle={this.props.onCloseClick}
          centered={true}
        >
          <ModalBody>
            <Row>
              <Col
                lg={18}
                style={{
                  textAlign: "center",
                }}
              >
                <div>
                  {" "}
                  <i
                    className="bx bx-check-circle"
                    style={{
                      marginTop: "15px",
                      fontSize: "3.5em",
                      color: "green",
                    }}
                  />
                  <h4>{this.props.messageText}</h4>
                </div>
              </Col>
            </Row>
            <ModalHeader style={{ marginBottom: "10px" }}></ModalHeader>
            <Row>
              <Col lg={12}>
                <div
                  style={{
                    textAlign: "center",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    onClick={this.props.onCloseClick}
                  >
                    {this.props.t("ok")}
                  </button>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

MessageModal.propTypes = {
  onCloseClick: PropTypes.func,
  messageText: PropTypes.any,
  messageDetailText: PropTypes.any,
  show: PropTypes.any,
  t: PropTypes.any,
};

export default withTranslation()(MessageModal);
